// @ts-strict-ignore
import { getIsApp } from '../../../../modules/AppInfo';
import {
  isAnonymous,
  ShareChannelFactory,
  ShareChannelMap,
  ShareProvider,
  ShareTarget,
  socialSharing,
} from '../../../../modules/share';
import { IS_MINE_MESSAGE } from '../constants';
import { providerAtSalon } from './helpers';

const shareViaPlugin = ({
  body,
  subject,
  onSuccess,
  onFail,
}) => () => {
  socialSharing().shareViaEmail(
    body,
    subject,
    null,
    null,
    null,
    null,
    onSuccess,
    onFail,
  );
};

const shareViaWeb = ({
  body,
  subject,
  onSuccess,
  onFail,
}) => () => {
  try {
    window.open(
      `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`,
    );
    onSuccess();
  } catch (error) {
    onFail(error);
  }
};

const getShareFunction = shareData => {
  if (getIsApp() && socialSharing()) {
    return shareViaPlugin(shareData);
  }
  return shareViaWeb(shareData);
};

type EmailContent = {
  subject: string;
  body: string;
};

const shareTextFunc = {
  [ShareTarget.PROFILE]: (provider, url, user): EmailContent => ({
    subject: (user && user.first_name) ? (`${user.first_name} thinks you'll like StyleSeat`) : 'Book your next appointment online with StyleSeat',
    body: 'Have you checked out StyleSeat? You can book online '
      + 'with the best beauty and wellness professionals in your neighborhood. '
      + `I think you'll like ${providerAtSalon(provider)}, check it out at ${url}`,
  }),
  [ShareTarget.PLATFORM]: (_, url, user): EmailContent => ({
    subject: (user && user.first_name) ? (`${user.first_name} thinks you'll like StyleSeat`) : 'Book your next appointment online with StyleSeat',
    body: 'Have you checked out StyleSeat? You can book online '
      + 'with the best beauty and wellness professionals in your neighborhood. '
      + `I think you'll like it, check it out at ${url}`,
  }),
};

const getShareText = (
  url: string,
  isMine: boolean,
  customText: string,
  content: EmailContent,
) => {
  if (customText) {
    return `${customText} ${url}`;
  }

  if (isMine) {
    return `${IS_MINE_MESSAGE} ${url}`;
  }

  return content.body;
};

const profileShare: ShareChannelFactory<ShareProvider | null> = (
  provider,
  url,
  user,
  onSuccess,
  onFail,
  message = {},
) => {
  let content: EmailContent;
  let isMine: boolean;
  if (provider) {
    isMine = !isAnonymous(user) && provider.id === user.provider_id;
    content = shareTextFunc[ShareTarget.PROFILE](provider, url, user);
  } else {
    isMine = false;
    content = shareTextFunc[ShareTarget.PLATFORM](provider, url, user);
  }

  return getShareFunction({
    body: getShareText(url, isMine, message.text, content),
    subject: message.title || content.subject,
    onSuccess,
    onFail,
  });
};

const MAP: ShareChannelMap = {
  [ShareTarget.PROFILE]: profileShare,
  [ShareTarget.SEARCH]: profileShare,
  [ShareTarget.PLATFORM]: profileShare,
};

export default MAP;
